const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change",
  cartError: "cart-error",
};

if (typeof window !== "undefined") {
  window.ON_CHANGE_DEBOUNCE_TIMER = window.ON_CHANGE_DEBOUNCE_TIMER || ON_CHANGE_DEBOUNCE_TIMER;
  window.PUB_SUB_EVENTS = window.PUB_SUB_EVENTS || PUB_SUB_EVENTS;
}
